export default __webpack_public_path__ + "static/media/layout2.346f5158.svg";